import { LoanTooSmallContactInfo } from '../../cards/contact-info-short/small-loan';
import DownPayment from '../../cards/down-payment';
import EarlyKickOut from '../../cards/early-kick-out';
import { Branch, Card, End } from '../../components/deck';
import { isPurchaseLargeEnough } from '../../modules/loan-size';

/**
 * Gets your Down Payment then branches to an early termination if your
 *   loan size is too small.
 *
 * @param {*} continuation - Path to continue on if validation passes
 */
export const DownPaymentBranch = (continuation) =>
  Card(
    DownPayment,
    Branch(
      {
        loanTooSmall: Card(LoanTooSmallContactInfo, Card(EarlyKickOut, End()))
      },
      ({ model }) => {
        const scenario = model.getIn(['loan', 'scenario']);
        // Determines your loan size based on purchase price minus down
        //   payment
        // This only checks the Preapproval flow
        // Purchase flow purchase size is checked after obtaining Veteran Status
        if (scenario === 'Preapproval' && !isPurchaseLargeEnough(model)) {
          return 'loanTooSmall';
        }
        return null;
      },
      continuation
    )
  );



// WEBPACK FOOTER //
// ./src/decks/branches/down-payment.js